
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexgbv4qnMaHge_17jvXGyDMnqz5BQl799JeD14IY6h2cAMeta } from "E:/Websites/RRnuxt1/pages/index.vue?macro=true";
import { default as logintMXZs9eVMJAgFyExpdtzIdRua_45FBtgr7CWWq7keNP0kMeta } from "E:/Websites/RRnuxt1/pages/login.vue?macro=true";
import { default as signupTxPneX3zUbo0Gli4aH8UPLBm3EkQQtmfiu771YyLRXsMeta } from "E:/Websites/RRnuxt1/pages/signup.vue?macro=true";
import { default as registerZOzXzYuVuJQhMRlCwX1_45ncaWv7EoFMNk7adGloRcx9IMeta } from "E:/Websites/RRnuxt1/pages/register.vue?macro=true";
import { default as contactUsu4NQqgZzh1BRW6GYTbhlQUruAmjGY_45CmI1ve0XcMpK0Meta } from "E:/Websites/RRnuxt1/pages/contactUs.vue?macro=true";
import { default as indexpOWHRPa3j5yJpiTbipqjvhF5VWaf7mtgi_45OfcFO6MWEMeta } from "E:/Websites/RRnuxt1/pages/admin/index.vue?macro=true";
import { default as indexGrNT2FK7rZ_MHgNdGvwcpEOg6W5oXwXHgUWPQlwNC70Meta } from "E:/Websites/RRnuxt1/pages/users/index.vue?macro=true";
import { default as unauthorizedigbrjiHdzSto9Rer_45nx_45Q0_4507qun0r24C2A1iQWVJ_YMeta } from "E:/Websites/RRnuxt1/pages/unauthorized.vue?macro=true";
import { default as _91id_93RVMko_iSNK3qZdP6WWtfYElJiF84_45IMbWOFzIjG6OrgMeta } from "E:/Websites/RRnuxt1/pages/listings/[id].vue?macro=true";
import { default as _91id_93RUPLPmJKe5vYBMOEEEFHyXQPRRnnkFQIEwpuSxpOO_gMeta } from "E:/Websites/RRnuxt1/pages/categories/[id].vue?macro=true";
import { default as create_45clientRoVbkZnz6JDBFfkf1TrvgCo6Kt0whxx_91E4ZrtSV0QMeta } from "E:/Websites/RRnuxt1/pages/users/create-client.vue?macro=true";
import { default as create_45listingp43pcar_0n8RYG5LqEVFWtHZcQjfWSQ9XhUvZ_zuC34Meta } from "E:/Websites/RRnuxt1/pages/users/create-listing.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("E:/Websites/RRnuxt1/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("E:/Websites/RRnuxt1/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("E:/Websites/RRnuxt1/pages/signup.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("E:/Websites/RRnuxt1/pages/register.vue")
  },
  {
    name: "contactUs",
    path: "/contactUs",
    component: () => import("E:/Websites/RRnuxt1/pages/contactUs.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexpOWHRPa3j5yJpiTbipqjvhF5VWaf7mtgi_45OfcFO6MWEMeta || {},
    component: () => import("E:/Websites/RRnuxt1/pages/admin/index.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexGrNT2FK7rZ_MHgNdGvwcpEOg6W5oXwXHgUWPQlwNC70Meta || {},
    component: () => import("E:/Websites/RRnuxt1/pages/users/index.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    component: () => import("E:/Websites/RRnuxt1/pages/unauthorized.vue")
  },
  {
    name: "listings-id",
    path: "/listings/:id()",
    component: () => import("E:/Websites/RRnuxt1/pages/listings/[id].vue")
  },
  {
    name: "categories-id",
    path: "/categories/:id()",
    component: () => import("E:/Websites/RRnuxt1/pages/categories/[id].vue")
  },
  {
    name: "users-create-client",
    path: "/users/create-client",
    meta: create_45clientRoVbkZnz6JDBFfkf1TrvgCo6Kt0whxx_91E4ZrtSV0QMeta || {},
    component: () => import("E:/Websites/RRnuxt1/pages/users/create-client.vue")
  },
  {
    name: "users-create-listing",
    path: "/users/create-listing",
    meta: create_45listingp43pcar_0n8RYG5LqEVFWtHZcQjfWSQ9XhUvZ_zuC34Meta || {},
    component: () => import("E:/Websites/RRnuxt1/pages/users/create-listing.vue")
  }
]